/**
 * routes-config.js
 *
 * This file maps individual route patterns to their target subdomains.
 * All routes default to the FIRST subdomain.
 *
 * Note: Routes can be extended or updated here so you can easily change the mapping.
 */

/**
 * AM3 route redirections - handles internal redirects within AM3
 * Each redirect is defined as a regex pattern with a handler function
 */
export const am3Redirects = [
  {
    pattern: /^\/campaigns\/(\d+)\/view\/dashboard$/,
    redirect: (match) => `/campaigns/view/${match[1]}#dashboard`
  }
]

//@formatter:off
export const routeMapping = {
  // 1. Dashboard
  '/':                             ['AM2'],
  // 2. Audience Management
  '/audience/[customer]/view':     ['AM3', 'AM2'],
  '/audience':                     ['AM3', 'AM2'],
  // 3. Campaign Management
  '/campaigns/setup':              ['AM2'],
  '/campaigns/new':                ['AM2'],
  '/campaigns/create':             ['AM3'],

  '/campaigns/[oid]/view':         ['AM2'],
  '/campaigns/view/[oid]':         ['AM3'],

  '/campaigns/[oid]/edit':         ['AM2'],
  '/campaigns/update':             ['AM3'],

  '/campaigns':                    ['AM3', 'AM2'],
  // 4. Event Management
  '/events':                       ['AM3', 'AM2'],
  // 5. Message Center
  '/message-center':               ['AM2'],
  '/message-preview':              ['AM2'],
  // 6. Automation
  '/automation':                   ['AM2'],
  // 7. Insights
  '/insights':                     ['AM2'],
  '/dashboard':                    ['AM2'],
  // 8. Tours
  '/tours':                        ['AM2'],
  // 9. Settings
  '/settings':                     ['AM2'],
  // 10. Custom Fields
  '/custom-fields':                ['AM2'],
  // 11. Authentication
  '/authenticate':                 ['AM3', 'AM2'],
  // 12. Admin Area
  '/admin':                        ['AM2'],
  '/plans':                        ['AM2'],
  // 13. Privacy Portal
  '/privacy-portal':               ['AM2'],
  // 14. Other
  '/maintenance':                  ['AM2'],
  '/ui':                           ['AM2'],
  '/example':                      ['AM2'],
  '/exceptions':                   ['AM2'],
}